import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Button,
  TextField,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  FormControl,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  button_bg_color_for_New_Project,
  settingsModal_bg_color_dm,
} from "../../../../../constants/colors";
import { AddLLMAgentForCallingAgent, getLLMAgentbyIdForCallingAgent, UpdateLLMAgentbyIdForCallingAgent } from "../../../../../contexts/WorkspaceUtils";
import CommonToast from "../../../../Common_Components/CommonToast";

const ModalForAddLLMAgent = ({ openAddAgentModal,setOpenAddAgentModal, HandleCloseButtonClick, fetchData, activeUserObject, setMoreActionOption }) => {

  const theme = localStorage.getItem("theme");
  const [toastopen, setToastopen] = useState(false);
  const [content, setContent] = useState("");
  const [iconType, setIconType] = useState('success');
  const [loading, setLoading] = useState(false);
  const [addLLMData, setAddLLMData] = useState({
    title : "",
    name:"",
    type:"",
    intro:"",
    tasks:""
  })

  useEffect(() => {
    if (!openAddAgentModal) {
      setAddLLMData({
        title: "",
        name: "",
        type: "",
        intro: "",
        tasks: ""
      });
    }
  }, [openAddAgentModal]);

  useEffect(()=>{
    if(activeUserObject){
      setAddLLMData(activeUserObject)
    }else{
      setAddLLMData({
        title : "",
        name:"",
        type:"",
        intro:"",
        tasks:""
      })
    }
  },[activeUserObject])
  

  const customTextFieldStylesforDropDownButton = {
    "& .MuiInputLabel-root": {
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: "0.5px",
      color: "rgba(255, 255, 255, 0.80)",
      "&.Mui-focused": {
        color: "rgba(255, 255, 255, 0.80) !important",
      },
    },
    "& .MuiInputBase-input": {
      color: "#FFFFFF",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgba(255, 255, 255, 0.80)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(255, 255, 255, 0.80)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(255, 255, 255, 0.80) !important",
      },
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
      color: "rgba(255, 255, 255, 0.80) !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(255, 255, 255, 0.80) !important",
    },
  };

  const customTextFieldStyles = (isInvalid) => {
    return {
      "& .MuiInputLabel-root": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "0.5px",
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
        },
      },
      "& .MuiInputBase-input": {
        color: "#FFFFFF",
      },
      "& #outlined-basic-label": {
        color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&:hover fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&.Mui-focused fieldset": {
          borderColor: isInvalid
            ? "#F2B8B5 !important"
            : "rgba(255, 255, 255, 0.80) ",
        },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
        color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80) ",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isInvalid
          ? "#F2B8B5 !important"
          : "rgba(255, 255, 255, 0.80) ",
      },
    };
  };

  const customTextFieldStylesForInvalid = () => {
    return {
      "& .MuiInputLabel-root": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "0.5px",
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: "rgba(255, 255, 255, 0.80)",
        },
      },
      "& .MuiInputBase-input": {
        color: "#FFFFFF",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "rgba(255, 255, 255, 0.80)",
        },
        "&:hover fieldset": {
          borderColor: "rgba(255, 255, 255, 0.80)",
        },
        "&.Mui-focused fieldset": {
          borderColor: "rgba(255, 255, 255, 0.80) ",
        },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
        color: "rgba(255, 255, 255, 0.80) ",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgba(255, 255, 255, 0.80) ",
      },
    };
  };


  const handleAddLLM = async () =>{
    setLoading(true)
    try{
      const jsonResponse = await AddLLMAgentForCallingAgent(addLLMData);
      const Response =await jsonResponse.json()
      if(Response?.status){
        setOpenAddAgentModal(false)
        HandleCloseButtonClick()
        setToastopen(true)
        setContent(Response?.message)
        setIconType('success')
        await fetchData()
      }else{
        setToastopen(true)
        setContent(Response?.message)
        setIconType('error')
      }
    }catch(error){
      console.error("API Error:", error);
      setToastopen(true)
      setContent(error?.message)
      setIconType('error')
    }finally{
      setLoading(false)
    }
  }

  const handleUpdateLLM = async () =>{
    setLoading(true)
    const newObj = {
      id : addLLMData?.id,
      title: addLLMData?.title,
      name: addLLMData?.name,
      type: addLLMData?.type,
      intro: addLLMData?.intro,
      tasks: addLLMData?.tasks,
    }
    try{
      const jsonResponse = await UpdateLLMAgentbyIdForCallingAgent( addLLMData?.id, newObj);
      const Response =await jsonResponse.json()
      if(Response?.status){
        setMoreActionOption(false)
        setOpenAddAgentModal(false)
        HandleCloseButtonClick()
        setToastopen(true)
        setContent(Response?.message)
        setIconType('success')
        await fetchData()
      }else{
        setToastopen(true)
        setContent(Response?.message)
        setIconType('error')
      }
    }catch(error){
      console.error("API Error:", error);
      setToastopen(true)
      setContent(error?.message)
      setIconType('error')
    }finally{
      setLoading(false)
    }
  }

  // const getLLMAgentData = async () =>{
  //   try{
  //     const jsonResponse = await getLLMAgentbyIdForCallingAgent();
  //     const response = await jsonResponse.json()
  //     if(response?.status){
  //       setOpenAddAgentModal(false)
  //       await fetchData()
  //     }else{
  //       setToastopen(true)
  //       setContent(Response?.message)
  //       setIconType('error')
  //     }
  //   }catch(error){
  //     console.error("API Error:", error);
  //     setToastopen(true)
  //     setContent(error?.message)
  //     setIconType('error')
  //   }
  // }
 
  const handleCloseToast = () =>{
    setToastopen(false)
  }

  return (
    <div>
      <Modal
        open={openAddAgentModal}
        onClose={HandleCloseButtonClick}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "16px",

        }}
      >
        <Box
          sx={{
            width: "640px",
            backgroundColor: "background.paper",
            boxShadow: 24,
            display: "flex",
            flexDirection: "column",
            bgcolor: theme === "dark" ? settingsModal_bg_color_dm : "",
            borderRadius: "8px",
            maxHeight:"80vh",
          }}
        >
          <Typography
            id=""
            variant="h6"
            component="h2"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              height: "68px",
              borderBottom: `1px solid ${
                theme === "dark" ? "rgba(255, 255, 255, 0.10)" : ""
              }`,
              padding: "20px",
              font: "Inter",
            }}
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: theme === "dark" ? "#FFFFFF" : "",
            }}
          >
            Add LLM agent
            <IconButton
              aria-label="close"
              onClick={HandleCloseButtonClick}
              sx={{
                // color: (theme) => theme.palette.grey[500],
                color: "#FFFFFF",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              padding: "40px 40px 0px 40px",
              overflowY: 'auto',
            }}
          >
            <Box
            // sx={{ overflow : ((isHeightUnder700px && window ===1) || (isHeightUnder600px) && window===0) ? "scroll" : "",height: ((isHeightUnder700px && window ===1) || (isHeightUnder700px) && window===0) ? "330px" : "", }}
            >
              <Box sx={{ marginBottom: 5 }}>
                <TextField
                  type="title"
                  onChange={(e)=>{setAddLLMData(prev => ({ ...prev, title: e.target.value }))}}
                  value={addLLMData?.title}
                  id="outlined-basic"
                  label="Title"
                  placeholder="Receptionist, BDR, etc."
                  variant="outlined"
                  sx={customTextFieldStyles(false)}
                  // sx={{...customTextFieldStyles(false),mt:5}}
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    height: "56px",
                    color: "#FFFFFF",
                    backgroundColor: "#232746",
                    borderRadius: "16px",
                    boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                    placeholderfontsize: "16px",
                  }}
                />
              </Box>

              <Box sx={{ marginBottom: 3 }}>
                <TextField
                  type="agentName"
                  onChange={(e)=>{setAddLLMData(prev => ({ ...prev, name: e.target.value }))}}
                  value={addLLMData?.name}
                  id="outlined-basic"
                  label="Agent Name"
                  placeholder="Enter agent name"
                  variant="outlined"
                  sx={customTextFieldStyles(false)}
                  // sx={{...customTextFieldStyles(false),mt:5}}
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    height: "56px",
                    color: "#FFFFFF",
                    backgroundColor: "#232746",
                    borderRadius: "8px",
                    boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                    placeholderfontsize: "16px",
                  }}
                />
                <FormHelperText
                  sx={{
                    color:
                      "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "16px",
                    margin: "4px 0px 0px 16px",
                    alignSelf: "start",
                  }}
                >
                  {`Name of the agent used to introduce itself`}
                </FormHelperText>
              </Box>

              <Box sx={{ minWidth: "100%", marginBottom: 3 }}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{
                      color: "rgba(255, 255, 255, 0.80)",
                      "&.Mui-focused": {
                        color: "rgba(255, 255, 255, 0.80) !important",
                      },
                    }}
                  >
                    Choose agent Type
                  </InputLabel>
                  <Select onChange={(e)=>{setAddLLMData(prev => ({ ...prev, type: e.target.value }))}}
                    sx={{
                      ...customTextFieldStylesforDropDownButton,
                      "& .MuiSelect-select": {
                        backgroundColor: "#282D51",
                      },
                      ".MuiSelect-icon": {
                        color: "#ffffff",
                      },
                    }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={addLLMData?.type}
                    label="Choose agent type"
                  >
                    <MenuItem
                      sx={{
                        bgcolor: "#2F355F",
                        marginTop: "-8px",
                        marginBottom: "-8px",
                        color: "white",
                        height: "56px",
                        "&:hover": {
                          bgcolor: "#393F69",
                        },
                        "&.Mui-selected": {
                          bgcolor: "#393F69 !important", // Ensure selected background color stays
                        },
                      }}
                      value={"Custom"}
                    >
                      Custom
                    </MenuItem>
                    {/* <MenuItem
                      sx={{
                        bgcolor: "#2F355F",
                        marginTop: "-8px",
                        marginBottom: "-8px",
                        color: "white",
                        height: "56px",
                        "&:hover": {
                          bgcolor: "#393F69",
                        },
                        "&.Mui-selected": {
                          bgcolor: "#282D51 !important", // Ensure selected background color stays
                        },
                      }}
                      value={"Receptionist"}
                    >
                      Receptionist
                    </MenuItem>
                    <MenuItem
                      sx={{
                        bgcolor: "#2F355F",
                        marginTop: "-8px",
                        marginBottom: "-8px",
                        color: "white",
                        height: "56px",
                        "&:hover": {
                          bgcolor: "#393F69",
                        },
                        "&.Mui-selected": {
                          bgcolor: "#393F69 !important", // Ensure selected background color stays
                        },
                      }}
                      value={"Outgoing Sales"}
                    >
                      Outgoing Sales
                    </MenuItem> */}
                  </Select>
                </FormControl>
                <FormHelperText
                  sx={{
                    color:
                      "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "16px",
                    margin: "4px 0px 0px 16px",
                    alignSelf: "start",
                  }}
                >
                  {`Type of agent that best represents your agent. Default is an assistant.`}
                </FormHelperText>
              </Box>

              <Box sx={{ marginBottom: 3 }}>
                <TextField  onChange={(e)=>{setAddLLMData(prev => ({ ...prev, intro: e.target.value }))}}
                  type="Intro sentence (optional)"
                  value={addLLMData?.intro}
                  id="outlined-basic"
                  label="Intro sentence (optional)"
                  placeholder="Hi, how can I help you?"
                  variant="outlined"
                  sx={customTextFieldStylesForInvalid()}
                  multiline
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    height: "112px",
                    color: "#FFFFFF",
                    backgroundColor: "#232746",
                    borderRadius: "8px",
                    boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                    placeholderfontsize: "16px",
                  }}
                  InputProps={{
                    style: {
                      height: "112px", // Ensures the input field fills the container height
                      padding: "20px 14px", // Adjust padding for better alignment
                      alignItems: "flex-start", // Ensures text starts from the top
                      overflow: "auto",
                    },
                  }}
                  InputLabelProps={{
                    style: {
                      whiteSpace: "normal", // Allows label text to wrap
                      // overflow: "visible", // Ensures the entire label is visible
                    },
                  }}
                />
                <FormHelperText
                  sx={{
                    color:
                      "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "16px",
                    margin: "4px 0px 0px 16px",
                    alignSelf: "start",
                  }}
                >
                  {`This is not translated. Please provide an intro that matches the language you selected.`}
                </FormHelperText>
              </Box>

              <Box sx={{ marginBottom: 0 }}>
                <TextField onChange={(e)=>{setAddLLMData(prev => ({ ...prev, tasks: e.target.value }))}}
                  type="text"
                  value={addLLMData?.tasks}
                  id="outlined-basic"
                  label="Tasks/Instructions"
                  placeholder="Enter list of tasks/instructions"
                  variant="outlined"
                  sx={customTextFieldStylesForInvalid()}
                  multiline
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    height: "112px",
                    color: "#FFFFFF",
                    backgroundColor: "#232746",
                    borderRadius: "8px",
                    boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                    placeholderfontsize: "16px",
                  }}
                  InputProps={{
                    style: {
                      height: "112px", // Ensures the input field fills the container height
                      padding: "20px 14px", // Adjust padding for better alignment
                      alignItems: "flex-start", // Ensures text starts from the top
                      overflow: "auto",
                    },
                  }}
                  InputLabelProps={{
                    style: {
                      whiteSpace: "normal", // Allows label text to wrap
                      // overflow: "visible", // Ensures the entire label is visible
                    },
                  }}
                />
                <FormHelperText
                  sx={{
                    color:
                      "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "16px",
                    margin: "4px 0px 0px 16px",
                    alignSelf: "start",
                  }}
                >
                  {`Task for agent to accomplish`}
                </FormHelperText>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              // boxShadow: "0px -4px 8px 0px rgba(0, 0, 0, 0.12)",
              p: 5,
            }}
          >
            <Button disabled={loading}
              variant="contained"
                onClick={activeUserObject ? ()=>handleUpdateLLM() : () => handleAddLLM()}
              sx={{
                backgroundColor:
                  theme === "dark" ? button_bg_color_for_New_Project : "",
                "&:hover": {
                  backgroundColor: "#FFD9AA",
                },
                color: "#17182C",
                fontSize: "16px",
                fontWeight: 600,
                textTransform: "none",
                fontFamily: "Inter, sans-serif",
                width: "100%",
                '&:disabled': {
                  backgroundColor: button_bg_color_for_New_Project
                }
              }}
            >
             { loading ?  <CircularProgress sx={{width:"16px", height:"16px", color:"#17182C"}}/> : activeUserObject ? "Update LLM Agent"  : "Add LLM agent" }
            </Button>
          </Box>
        </Box>
      </Modal>
      <CommonToast open={toastopen} onClose={handleCloseToast} content={content} iconType={iconType} bgColor={"#282D51"}/>
    </div>
  );
};

export default ModalForAddLLMAgent;
